module.exports = __webpack_public_path__ + "img/wine-placeholder-white.85ba7709.png";